"use client";

import { useState } from "react";
import { UserRound } from "@app-foundation/icons/lucide";

type PhotoProps = { src?: string; label: string; className: string; shape?: "rectangle" | "circle" };

function Photo({ src, label, className, shape = "rectangle" }: PhotoProps) {
  const [failed, setFailed] = useState(false);
  return <div data-corner-shape={shape === "circle" || className.includes("rounded-full") ? "round" : undefined} className={`overflow-hidden ${shape === "circle" ? "rounded-full" : "rounded-xl"} bg-[var(--color-surface)] ${className}`}>
    {src && !failed ?
      // Owner photos use CloudBase URLs directly so expired URLs are not kept in an image proxy cache.
      // eslint-disable-next-line @next/next/no-img-element
      <img src={src} alt={label} className={`h-full w-full ${shape === "circle" ? "object-cover" : "object-contain"}`} onError={() => setFailed(true)} />
      : shape === "circle" ? <div role="img" aria-label={`${label}：${src ? "暂时无法加载" : "尚未上传"}`} className="flex h-full w-full items-center justify-center bg-[var(--color-tint)] text-[var(--color-muted)]"><UserRound size={36} aria-hidden="true" /></div> : <div className="flex h-full items-center justify-center p-3 text-center text-sm text-[var(--color-muted)]">{src ? "照片暂时无法加载，请刷新重试" : "暂无可显示的照片"}</div>}
  </div>;
}

export function AvatarPhoto(props: PhotoProps) {
  return <Photo key={props.src ?? "missing"} {...props} />;
}
